type FieldErrorProps = {
  message?: string;
};

export function FieldError({ message }: FieldErrorProps) {
  return (
    <p className="mt-1 min-h-[14px] text-[11px] leading-none text-red-500">
      {message || '\u00A0'}
    </p>
  );
}

export function authInputClass(hasError?: boolean) {
  return `signup-input box-border h-[52px] w-full min-w-0 rounded-[16px] border bg-white px-3.5 text-sm leading-none text-[#2E2A54] outline-none transition-[border-color,box-shadow] placeholder:text-[#A9A6BE] ${
    hasError ? 'border-red-400' : 'border-[#E5E2F0] hover:border-[#8156B4]'
  }`;
}

export function authFieldWrapClass(hasError?: boolean) {
  return `signup-input box-border flex h-[52px] w-full min-w-0 items-center rounded-[16px] border bg-white transition-[border-color,box-shadow] ${
    hasError ? 'border-red-400' : 'border-[#E5E2F0] hover:border-[#8156B4]'
  }`;
}
